import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { verifyAdmin } from '../api/adminAuth';
import Cookies from 'js-cookie';

const ProtectedRoute = ({ children }) => {
  const { activityId } = useParams();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        setIsLoading(true);
        const token = Cookies.get('adminToken');
        if (!token) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }

        await verifyAdmin(token);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Authentication error:', error);
        setIsAuthenticated(false);
        Cookies.remove('adminToken');
      } finally {
        setIsLoading(false);
      }
    };

    verifyAuth();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }

  if (!isAuthenticated) {
    return <Navigate to={`/admin/${activityId}/login?redirect=${location.pathname}`} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 